import { render, staticRenderFns } from "./deleteUnit.vue?vue&type=template&id=0c2d4e90"
import script from "./deleteUnit.vue?vue&type=script&lang=js"
export * from "./deleteUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports